import Vue from 'vue'
import Vuex from 'vuex'
// importar modulos

// plugin a agregar
import  createPersistedState  from  'vuex-persistedstate'

// Import de drag and drop 
import defaultBoard from '@/components/dragdrop/default-board.js'


// se busca si localmentente en el storage existe informacion bajo el nombre de board sino se carga el por default
const board = JSON.parse(localStorage.getItem('board')) || defaultBoard

//Modulos
import notificaciones from '@/store/modulos/notificaciones.js'
import BuildCorreos from '@/store/modulos/buildCorreos.js'
import dinamicos from '@/store/modulos/dinamicos.js'
import detalle from '@/store/modulos/detalle.js'
import jsIdioma from '@/store/modulos/idioma.js'
import filterSeccion from '@/store/modulos/filterSeccion.js'
import indicadores from '@/store/modulos/indicadores.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    snackbar            : false, 
    mensajeNotificacion : '',
    login               : false, 
    token               : '',          // token del usuario registrado
    idUser              : '',          // id Usuario logueado
    sSubDominio         : '',          //subdominio del cliente         
    latlng              : {},          // objeto de latitud longitud 
    oFormError          : {},          // menejo de error en los formularios
    idDeparment         : '',          // Id departamento usuario
    idModule            : '',          // Id Modulo activo
    sTitleModule        : '',          // Titulo del modulo activo
    oPermission         : {},          // Objetos de permisos
    sParamsExt          : '',          // Parametros adicionales en la URL incluye nombre del proyecto al cual se hara la conexión
    board,                             // Variable para manejo de board de construir BuildDinamicos    
    componentSelect     : {},          // Aqui se cargara el componente seleccionado para mostarlo en confguracion BuildDinamicos
    nIdPrevPage         : '',
    idPerfil            : '',          // Id peril del usuario
    idCliente           : '',          // Id cliente del pqr externo
    selectedProcessImport: {},
    processImport       : '',
    dataImport          : [],
    processesImport     : [],
    processesImportNames: [],
    bIncrustado         : false,       // Se emplea para quitar la barra lateral cuando es llamada de forma externa
    bIncrustadoSuperior : false,       // Se emplea para quitar la barra superior cuando es llamada de forma externa
    sIdPqrPerfil: '',
    sDependencias: '',
    sNombreUsuario: '',                // Esta variable almacena el nombre de usuario
    aDiccionario: [],
    sBeforePath         : '',           // En esta variable se guarda la name de la ruta de donde vengo, si esta vacia es por que estoy iniciando 
    bRestorePass: false,                  // Con esta variable se valida que el usuario tenga que restaurar la clave obliggatoriamente  
    sIP        :'',                  // Con esta variable se guardara la ip con la que el usuario se logueo
  },
  getters: {
    getsnackbar: (state) => {
      return state.snackbar;
    },
    getmensajeNotificacion: (state) => {
      return state.mensajeNotificacion;
    },
    getLogin : (state) => {
      return state.login;
    },
    getToken : (state) => {
      return state.token;
    },
    getIdPerfil : (state) => {
      return state.idPerfil;
    },
    getIdCliente: (state) => {
      return state.idCliente;
    },
    getIdUser : (state) => {
      return state.idUser;
    },
    getsNombreUsuario : (state) => {
      return state.sNombreUsuario;
    },
    getDomain : (state) => {
      return state.sSubDominio;
    },
    getlatlng : (state) => {
      return state.latlng;
    },
    getoFormError : (state) => {
      return state.oFormError;
    },
    getIdDeparment : (state) => {
      return state.idDeparment;
    },
    getIdModule : (state) => {
      return state.idModule;
    },
    getTitleModule : (state) => {
      return state.sTitleModule;
    },
    getPermisionUser : (state) => {
      return state.oPermission;
    },
    getsParams : (state) => {
      return state.sParamsExt
    },
    getProcessImport : (state) => {
      return state.processImport
    },
    getSelectedProcessImport : (state) => {
      return state.selectedProcessImport
    },
    getProcessesImportNames : (state) => {
      return state.processesImportNames
    },
    getProcessesImport : (state) => {
      return state.processesImport
    },
    getDataImport : (state) => {
      return state.dataImport
    },
    getbIncrustado : (state) => {
      return state.bIncrustado
    },
    getbIncrustadoSuperior : (state) => {
      return state.bIncrustadoSuperior
    },
    // -------------------- Seccion buildDinamicos  --------------------------------

    getsboard : (state) => {
      return state.board
    },
    getscomponentSelect : (state) => {
      return state.componentSelect
    },
    getidFormulario : (state) => {
      return state.board.columns[1].idFormulario
    },
    // -------------------- FIN Seccion buildDinamicos  --------------------------------

    getIdPrevPage : (state) => {
      return state.nIdPrevPage
    },

    // ------------------------------------ Sección import ------------------------------
    getsBeforePath : (state) => {
      return state.sBeforePath
    },
    // ------------------------------------ Fin sección import --------------------------
    getbRestorePass : (state) => {
      return state.bRestorePass
    },

    getsIP : (state) => {
      return state.sIP;
    },
  },
  mutations: {
    NOTIFICAR : (state, estado) => {
      state.snackbar = estado;
    },
    SETIDPERFIL: (state, value) => {
      state.idPerfil = value;
    },
    SETIDCLIENTE: (state, value) => {
      state.idCliente = value;
    },
    SETDICCIONARIO: (state, value) => {
      state.aDiccionario = value;
      value.forEach(oItem => {
        state.jsIdioma.oEquivalencias[oItem['variable']] = oItem[state.jsIdioma.sIdiomaPred]
      })
    },
    MENSAJE : (state, estado) => {
      state.mensajeNotificacion = estado;
    },
    SETLOGIN: (state,value) => {
      state.login = value;
    },
    SETTOKEN: (state,value) => {
      state.token = value;
    },
    SETIDUSER: (state, value) => {
      state.idUser = value;
    },
    SETSNOMBREUSUARIO: (state, value) => {
      state.sNombreUsuario = value;
    },
    SETSUBDOMAIN: (state, value) => {
      state.sSubDominio = value;
    },
    SETLATLNG: (state, value) => {
      state.latlng = value;
    },
    SETFORMERROR: (state, value) => {
      state.oFormError = value;
    },
    SETIDDEPARMENT: (state, value) => {
      state.idDeparment = value;
    },
    SETIDMODULE: (state, value) => {
      state.idModule = value;
    },
    SETTITLEMODULE: (state, value) => {
      state.sTitleModule = value;
    },
    SETPERMISSION: (state, value) => {
      state.oPermission = value
    },
    SETPARAMS: (state, value) => {
      state.sParamsExt = value
    },
    SAVE_PROCESS_IMPORT : (state, value) => {
      state.processImport = value
    },
    // IMPORT
    SAVE_SELECTED_PROCESS_IMPORT : (state, value) => {
      state.selectedProcessImport = value
    },
    SAVE_PROCESSES_IMPORT_NAMES : (state, value) => {
      state.processesImportNames = value
    },
    SAVE_PROCESSES_IMPORT : (state, value) => {
      state.processesImport = value
    },
    SAVE_DATA_IMPORT : (state, value) => {
      state.dataImport = value
    },
    SAVE_TIMESTAMP_IMPORT : (state, value) => {
      state.timestampImport = value
    },
    // IMPORTS END
    SETBINCRUSTADOSUPERIOR: (state, value) => {
      state.bIncrustadoSuperior = value
    },
    SETBINCRUSTADO: (state, value) => {
      state.bIncrustado = value
    },
    SAVEFILTROCIUDADES: (state, value) => {
      state.sFiltroClientes = value
    },
    SAVEIDPQRPERFIL : (state, value) => {
      state.sIdPqrPerfil = value
    },
    // -------------------- Seccion buildDinamicos  --------------------------------
    SAVE_BOARD (state, value) {
      state.board = value
    },
    SAVE_CAMPOBOARD (state, value) {
      state.board.columns[1].campos.splice([value.camposIndex],1,value.campo)
    },
    UPDATE_CAMPO (state, { task, key, value }) {
      task[key] = value
    },
    DELETE_CAMPO (state,Index){
      board.columns[1].campos.splice(Index,1)
    },
    MOVE_CAMPO (state, { fromTasks, toTasks, fromTaskIndex, toTaskIndex, fromColumn, toColumn  }) {
      // si se mueva en la misma columna elimino la posicion inicial
      if(fromColumn == toColumn){
        const taskToMove = fromTasks.splice(fromTaskIndex, 1)[0]
        
        toTasks.splice(toTaskIndex === undefined ? toTasks.length : toTaskIndex, 0, taskToMove)
      } else {
        if(toColumn != 'Tipos de Campos'){
          toTasks.splice(toTaskIndex === undefined ? toTasks.length : toTaskIndex, 0, fromTasks[fromTaskIndex])
        } else {
          // Como saco el registro de Fomulario lo borro
          fromTasks.splice(fromTaskIndex, 1)[0]
        }
      }
    },
    CHANGE_COMPONENTSELECT (state, NewComponentSelect){
     state.componentSelect = NewComponentSelect
    },
    SAVE_FORMULARIO (state, value){
      state.board.columns[1].idFormulario = value
    },
    CLEAN_CAMPOS (state) {
      state.board.columns[1].campos = []
    },
    // -------------------- FIN Seccion buildDinamicos  --------------------------------


    SAVE_IDPREVPAGE (state, value) {
      state.nIdPrevPage = value
    },
    // ------------------------ Sección import -----------------------------------------
    SAVEDEPENDENCIAS : (state, value) => {
      state.sDependencias = value
    },
    SAVE_SBEFOREPATH : (state, value) => {
      state.sBeforePath = value === null ? '' : value
    },
    // ------------------------ Fin Sección import  ------------------------------------
    SAVE_BRESTOREPASS : (state, value) => {
      state.bRestorePass = value === null ? false : value
    },
    SAVEIP : (state, value) => {
      state.sIP = value === null ? '' : value
    },
  },
  actions : {
    ShowNotificacion({commit}, estado) {
      commit('NOTIFICAR', estado);
    },
    saveIdPerfil({commit}, value){
      commit ('SETIDPERFIL', value)
    },
    saveIdCliente({commit}, value) {
      commit('SETIDCLIENTE', value)
    },
    saveDiccionario({commit}, value){
      commit ('SETDICCIONARIO', value)
    },
    SetMensaje({commit}, estado) {
      commit('MENSAJE', estado);
    },
    setLogin({commit}, value){
      commit ('SETLOGIN', value)
    },
    saveToken({commit}, value){
      commit ('SETTOKEN', value)
    },
    saveIdUser({commit}, value){
      commit ('SETIDUSER', value)
    },
    savesNombreUsuario({commit}, value) {
      commit('SETSNOMBREUSUARIO', value)
    },
    saveSubDomain({commit}, value){
      commit ('SETSUBDOMAIN', value)
    },
    savelatlng({commit}, value){
      commit ('SETLATLNG', value)
    },
    saveProcessImport({commit}, value) {
      commit ('SAVE_PROCESS_IMPORT', value)
    },
    saveSelectedProcessImport({commit}, value) {
      commit ('SAVE_SELECTED_PROCESS_IMPORT', value)
    },
    saveProcessesImport({commit}, value) {
      commit('SAVE_PROCESSES_IMPORT', value)
    },
    saveProcessesImportNames({commit}, value) {
      commit ('SAVE_PROCESSES_IMPORT_NAMES', value)
    },
    saveDataImport({commit}, value) {
      commit ('SAVE_DATA_IMPORT', value)
    },
    saveTimestampImport({commit}, value) {
      commit ('SAVE_TIMESTAMP_IMPORT', value)
    },
    saveoFormError({commit}, value){
      commit ('SETFORMERROR', value)
    },
    saveIdDeparment({commit}, value){
      commit ('SETIDDEPARMENT', value)
    },
    saveIdModule({commit}, value){
      commit ('SETIDMODULE', value)
    },
    saveTitleModule({commit}, value){
      commit ('SETTITLEMODULE', value)
    },
    savePermissions({commit}, value){
      commit ('SETPERMISSION', value)
    },
    saveParamsProyect({commit}, value) {
      commit ('SETPARAMS', value)
    },

    savebIncrustado ({commit}, value ){
      commit ('SETBINCRUSTADO', value)
    },
    savebIncrustadoSuperior ({commit}, value ){
      commit ('SETBINCRUSTADOSUPERIOR', value)
    },
    saveIdPqrPerfil({commit}, value) {
      commit ('SAVEIDPQRPERFIL', value)
    },
    saveDependencias({commit}, value) {
      commit ('SAVEDEPENDENCIAS', value)
    },
    // -------------------- Seccion buildDinamicos  --------------------------------

    salvarBoard({commit}, value) {
      commit ('SAVE_BOARD', value)
    },
    cambiarComponentSelet({commit}, value) {
      commit ('CHANGE_COMPONENTSELECT', value)
    },
    salvarCampoBoard({commit}, value) {
      commit ('SAVE_CAMPOBOARD', value)
    },
    salvarFormulario({commit}, value){
      commit ('SAVE_FORMULARIO', value)
    },
    cleanCampos ({commit}){
      commit ('CLEAN_CAMPOS')
    },
    // -------------------- FIN Seccion buildDinamicos  --------------------------------

    saveIdPrevPage ({commit}, value) {
      commit ('SAVE_IDPREVPAGE', value)
    },

    // -------------------------- Sección import ---------------------------------------- 
    save_sBeforePath({commit}, value) {
      commit ('SAVE_SBEFOREPATH', value)
    },
    // -------------------------- Fin Sección import ------------------------------------
    save_bRestorePass({commit}, value) {
      commit ('SAVE_BRESTOREPASS', value)
    },
    save_sIP({commit}, value) {
      commit ('SAVEIP', value)
    },
  },
  modules: {
    // para el manejo de modulos se debe tener en cuenta que toca anteceder el mnombre del modulo 
    // guia de uso https://vuex.vuejs.org/guide/modules.html#module-local-state
    notificaciones,
    BuildCorreos,
    dinamicos,
    detalle,
    filterSeccion,
    jsIdioma,
    indicadores
  }, 
  // aquí agregamos el plugin
	plugins: [createPersistedState()]
});